import axios, { AxiosResponse } from "axios"
import { checkResponseStatus } from "@api/Utils"
import { EntityListResponseShopType, SystemCategory } from "cs.node.utils/csapi/provisioning";

const getShopTypes = async()=>{
    try{
        const response:AxiosResponse<EntityListResponseShopType,any> = await axios.get(`api/shop-types/`)
        return response.data
    } 
    catch(error:any) { 
        checkResponseStatus(error)
        throw error
    }
}

const getShopTypesCategories = async (shopId: String) =>{
    try{
        const response:AxiosResponse<SystemCategory[],any> = await axios.get(`api/shop-types/${shopId}/categories`)
        return response.data
    } 
    catch(error:any) { 
        checkResponseStatus(error)
        throw error
    }
}

export { getShopTypesCategories, getShopTypes }